

























import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { DateEditableMixin } from "./mixins";
import ComboBoxSelector from "./ComboBoxSelector.vue";

@Component({
  components: {
    ComboBoxSelector,
  }
})
export default class TimeEditor extends Mixins(DateEditableMixin) {
  get hourOptions(): number[] {
    return Enumerable.rangeTo(0, 23).toArray();
  }

  get minuteOptions(): number[] {
    return Enumerable.rangeTo(0, 59).toArray();
  }
}
